













import Vue from "vue";
import Header from "@/layout/Header.vue";
import Footer from "@/layout/Footer.vue";
import Breadcrumbs from "@/components/Breadcrumbs.vue";

export default Vue.extend({
  name: "App",
  data: () => ({
    //
  }),
  components: {
    Header,
    Footer,
    Breadcrumbs,
  },
});
